export default "__VITE_ASSET__BXzYBfoK__"